import _Dropzone from 'react-dropzone';

import { FileUploadInput } from '../../form/FileUploadInput/index.js';

// cjs -> esm issue
const Dropzone = _Dropzone as any as typeof _Dropzone['default'];
const ONE_MB = 1024 * 1024;

import { Controller } from 'react-hook-form';

import { useFileUploadApiEffects } from './FileUploadApi.effects.js';
import type { FileUploadApiProps } from './FileUploadApi.types.js';

/**
 * Same as FileUpload but through API - based on RJSF FileWidgetApi.
 */
export const FileUploadApi = (props: FileUploadApiProps) => {
  const { control, field } = props;

  return (
    <Controller
      name={field.name}
      control={control}
      render={({ field: { onChange, value } }) => {
        /** @TODO  */
        return <DropzoneWithApi {...field} value={value} onChange={onChange} />;
      }}
    />
  );
};

type DropzoneWithApiProps = FileUploadApiProps['field'] & { value?: string | string[]; onChange: (value: unknown) => void };

const DropzoneWithApi = ({
  fileProps,
  name,
  value,
  onChange,
}: DropzoneWithApiProps) => {
  const multiple = fileProps?.multiple ?? true;
  const accept = fileProps?.accept ?? {};
  const maxFiles = fileProps?.maxFiles ?? 10;
  const maxSize = fileProps?.maxSize ?? 3 * ONE_MB;

  const {
    files,
    onDrop,
    onDropRejected,
    rejectedFiles,
    removeRejectedFile,
    removeFile,
    openFile,
    isLoading,
  } = useFileUploadApiEffects({
    multiple,
    name,
    onChange,
    value,
    loadPreview: fileProps?.loadPreview ?? false,
  });

  return (
    <Dropzone
      accept={accept}
      multiple={multiple}
      onDropRejected={onDropRejected}
      maxFiles={maxFiles}
      maxSize={maxSize}
      onDrop={onDrop}
    >
      {({ getRootProps, getInputProps }) => {
        return (
          <FileUploadInput
            files={files.map(f => f.name)}
            getRootProps={getRootProps}
            getInputProps={getInputProps}
            rejectedFiles={rejectedFiles}
            removeRejectedFile={removeRejectedFile}
            removeFile={removeFile}
            openFile={openFile}
            showDownload
            uploadInProgress={isLoading}
          />
        );
      }}
    </Dropzone>
  );
};
